// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--3c3vY","content":"hero-module--content--2CQ_p","heroImage":"hero-module--heroImage--3huMi"};